import { FC, useMemo } from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { ITextField, TextField } from './TextField';

interface IProps extends ITextField {
  formikProps: FormikProps<any>;
}

export const TextFieldFormikWrapper: FC<IProps> = (props) => {
  const { formikProps, name, ...rest } = props;
  const { values, errors, touched, setFieldValue } = formikProps;

  const { t } = useTranslation();

  const errorMessage = useMemo((): string => {
    if (!errors[name] || !touched[name]) return '';
    if (typeof errors[name] === 'string') return t(`${errors[name]}`);
    const { data, message }: any = errors[name];
    return t(message, data);
  }, [errors[name], touched[name], t]);

  const handleChange = (name: string, value: any) => {
    setFieldValue(name, value);
  };

  return (
    <TextField
      error={errorMessage}
      value={values[name]}
      onChange={handleChange}
      name={name}
      {...rest}
    />
  );
};
